import React from 'react';
import { GetPriorityIcon } from './fetchIcons';

class Stack extends React.Component {
  state = {
    nutritionalOpen: false,
    ingredientsOpen: false,
    nutritionalCollapsing: false,
    ingredientsCollapsing: false,
  };

  toggleNutritional(e) {
    e.preventDefault();
    this.setState({
      nutritionalCollapsing: !this.state.nutritionalCollapsing,
    });
    setTimeout(() => {
      this.setState({
        nutritionalCollapsing: !this.state.nutritionalCollapsing,
        nutritionalOpen: !this.state.nutritionalOpen,
      });
    }, 1000);
  }

  toggleIngredients(e) {
    e.preventDefault();
    this.setState({
      ingredientsCollapsing: !this.state.ingredientsCollapsing,
    });
    setTimeout(() => {
      this.setState({
        ingredientsCollapsing: !this.state.ingredientsCollapsing,
        ingredientsOpen: !this.state.ingredientsOpen,
      });
    }, 1000);
  }

  render() {
    if (this.props.quizResults.priority !== null) {
      return (
        <div className="quiz-stack__content">
          <h1 className="results__heading">
            <img src="//images.accentuate.io?c_options=w_32,h_32,dpr_auto&amp;image=https://cdn.accentuate.io/4165996871757/11303571587149/Inner-Peace-v1573639653561.svg?32x32" srcSet="//images.accentuate.io?c_options=w_32,h_32,dpr_2.0&amp;image=https://cdn.accentuate.io/4165996871757/11303571587149/Inner-Peace-v1573639653561.svg?32x32 2x" alt="" aria-hidden="true" />
            {this.props.quizResults.firstName.charAt(0).toUpperCase() + this.props.quizResults.firstName.slice(1)}&rsquo;s Stack
          </h1>
          <p className="results__intro">
            {this.props.quizResults.firstName.charAt(0).toUpperCase() + this.props.quizResults.firstName.slice(1)}, here's your personalised Nourished stack. We recommend these 7 Nourishments to help optimise your lifestyle, diet and priorities.
          </p>
          <ul>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" className="svgCheck" viewBox="0 0 515.556 515.556" width="20" height="20"><path d="m0 274.226 176.549 176.886 339.007-338.672-48.67-47.997-290.337 290-128.553-128.552z" /></svg>
              {this.props.quizResults.gender.toLowerCase() === 'male' || this.props.quizResults.gender.toLowerCase() === 'female' ? `${this.props.quizResults.gender.charAt(0).toUpperCase() + this.props.quizResults.gender.slice(1)}, ` : ''}
              {this.props.quizResults.age}
              {this.props.quizResults.selectedDiets ? `, ${this.props.quizResults.selectedDiets.toLowerCase()}` : ''}
              {this.props.quizResults.natalAnswers && this.props.quizResults.natalAnswers.toLowerCase() !== 'no' ? `, ${this.props.quizResults.natalAnswers}` : ''}
            </li>
            <li>
              {GetPriorityIcon(this.props.quizResults.priority[0])}
              {this.props.quizResults.priority[0]}
            </li>
            <li>
              {GetPriorityIcon(this.props.quizResults.priority[1])}
              {this.props.quizResults.priority[1]}
            </li>
          </ul>
        </div>
      );
    } else {
      return (
        <div className="quiz-stack__content">
          <h1 className="results__heading">
            <img src="//images.accentuate.io?c_options=w_32,h_32,dpr_auto&amp;image=https://cdn.accentuate.io/4165996871757/11303571587149/Inner-Peace-v1573639653561.svg?32x32" srcSet="//images.accentuate.io?c_options=w_32,h_32,dpr_2.0&amp;image=https://cdn.accentuate.io/4165996871757/11303571587149/Inner-Peace-v1573639653561.svg?32x32 2x" alt="" aria-hidden="true" />
            {this.props.quizResults.firstName.charAt(0).toUpperCase() + this.props.quizResults.firstName.slice(1)}&rsquo;s Nourished
          </h1>
          <p className="results__intro">
            {this.props.quizResults.firstName.charAt(0).toUpperCase() + this.props.quizResults.firstName.slice(1)}, here's your personalised Nourished stack. We recommend these 7 Nourishments to help optimise your lifestyle, diet and priorities.
          </p>
        </div>
      );
    }
  }
}

export default Stack;
